const ACTIONS_TYPE = {
  PROTOCOLO: {
    REMOVER_CONTRATO: 'protocolo_remove_contrato',
    CANCELAR: 'protocolo_cancelar',
    IMPRIMIR: 'protocolo_imprimir',
  },
  RECEPCAO: {
    IMPRIMIR_CAIXA: 'recepcao_imprimir_caixa',
    REIMPRIMIR_CAIXA: 'recepcao_reimprimir_caixa',
  },
};

const LOGS = {
  ACTIONS_TYPE,
};

export { LOGS };
